import { css, nothing } from 'lit'
import { html, unsafeStatic } from 'lit/static-html.js'
import HHQuizElement from '../element.js'
import { decode } from '../../lib/utils/general.js'

/**
 * Product Card Description
 * @extends
 */

class HHQuizProductCardDescription extends HHQuizElement {

  static properties = {
    variant: { type: Object },
    showDescription: { type: Boolean },
    showDescriptionMore: { state: true },
  }

  constructor() {
    super()
    this.showDescriptionMore = false
  }

  get description() {
    return decode(this.variant.product.description).split('<br>')[0].replaceAll('<p>', '').replaceAll('</p>', '')
  }

  get descriptionMore() { 
    const description = decode(this.variant.product.description).split('<br>')
    description.shift()
    if (!description[0]) description.shift()
    return decode(`${description.join('<br>')}${this.variant.product.richDescription}`).replaceAll('<p>', '').replaceAll('</p>', '')
  }

  /**
   * Renders product card description with 'read more' toggle
   * @returns {TemplateResult}
   */
  render() {
    return html`${this.showDescription && (this.description || this.descriptionMore) ? html`
          <div class="caption hh-quiz-product-card__description" tabindex="0">
            ${unsafeStatic(decode(this.description))}${this.descriptionMore ? html`${this.showDescriptionMore ? html`<div class="hh-quiz-product-card__description__rich">${unsafeStatic(this.descriptionMore)}</div>`: nothing} <button @keydown="${(ev) => ev.stopPropagation()}" @click="${() => this.showDescriptionMore = !this.showDescriptionMore}">${this.showDescriptionMore ? HH_QUIZ.t.actions.show_less: HH_QUIZ.t.actions.show_more}</button>` : nothing}
          </div>
        ` : ''}
    `
  }

  static styles = [
    HHQuizElement.styles,
    css`
      .hh-quiz-product-card__description * {
        font-size: inherit;
        font-family: inherit;
      } 

      .hh-quiz-product-card__description button {
        margin: 0;
        padding: 0;
        font-size: inherit;
        font-family: inherit;
        font-weight: bold;
        text-decoration: underline;
        background: none;
        border: none;
        cursor: pointer;
      }

      .hh-quiz-product-card__description__rich {
        margin: 20px 0;
      }
    `,
  ]
}

customElements.define(
  'hh-quiz-product-card-description',
  HHQuizProductCardDescription
)
